import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConsts } from 'src/app/shared/app-consts';

@Injectable({
  providedIn: 'root'
})
export class ForceChangePasswordService implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const identifier = localStorage.getItem(AppConsts.Session_ForceChangePassword) ?? '';
    // Check if the user needs to change their password
    if (identifier) {
      // Redirect to the change password route
      return this.router.parseUrl('/reset-password');
    } else {
      return true; // Allow navigation
    }
  }
}
